import { httpRequest } from "@services/http";

// A (step, dimension) pair is the cell that pricing and conversions reference — "Register for
// Classes / Fall 2026". Nested under the step because that is the only place it means anything,
// and addressed through the journey so a step id from elsewhere cannot reach these.
export interface JourneyStepDimension {
  id: number;
  journey_step_id: number;
  code: string;
  name: string;
  sequence: number;
}

export interface JourneyStepDimensionPayload {
  code: string;
  name: string;
  sequence: number;
}

const url = (journeyId: number, stepId: number, id?: number) => {
  const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/journeys/${journeyId}/steps/${stepId}/dimensions/`;
  return id ? `${base}${id}/` : base;
};

export class CommandListJourneyStepDimensions {
  async run(journeyId: number, stepId: number): Promise<JourneyStepDimension[]> {
    return httpRequest<JourneyStepDimension[]>(url(journeyId, stepId));
  }
}

export class CommandCreateJourneyStepDimension {
  async run(journeyId: number, stepId: number, payload: JourneyStepDimensionPayload) {
    return httpRequest<JourneyStepDimension>(url(journeyId, stepId), {
      method: "POST", body: JSON.stringify(payload),
    });
  }
}

export class CommandUpdateJourneyStepDimension {
  async run(journeyId: number, stepId: number, id: number, payload: JourneyStepDimensionPayload) {
    return httpRequest<JourneyStepDimension>(url(journeyId, stepId, id), {
      method: "PUT", body: JSON.stringify(payload),
    });
  }
}

export class CommandDeleteJourneyStepDimension {
  async run(journeyId: number, stepId: number, id: number): Promise<void> {
    await httpRequest(url(journeyId, stepId, id), { method: "DELETE" });
  }
}
